import React from "react";

export default function FooterSocials() {
  const socials = [
    { name: "Instagram", icon: "fa-instagram", url: "https://www.instagram.com/briancalli.music/" },
    { name: "YouTube", icon: "fa-youtube", url: "https://www.youtube.com/@briancallimusic" },
    { name: "Facebook", icon: "fa-facebook", url: "https://www.facebook.com/profile.php?id=61577808613336" },
  ];

  return (
    <>
      {socials.map((social, index) => (
        <li key={index}>
          <a href={social.url} rel="noopener nofollow" target="_blank">
            <i className={social.icon} /> {social.name}
          </a>
        </li>
      ))}
    </>
  );
}
